import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'; // useNavigate is inside BrowserRouter
import Login from './Login';
import LoginWithOtp from './LoginWithOtp';
import ForgotPassword from './ForgotPassword';
import Terms_Conditions from './Terms_Conditions';
import SalesDashboard from './SalesDashboard';
import AddNewPlumber from './AddNewPlumber';
import PendingForApproval from './PendingForApproval';
import ApprovedPlumber from './ApprovedPlumber';
import RejectedPlumber from './RejectedPlumber';
import SalesEnrollmentReport from './Sales_Reports/SalesEnrollmentReport';
import EnrollkmentReport from './Sales_Reports/EnrollkmentReport';
import SalesQrTransactionReport from './Sales_Reports/SalesQrTransactionReport';
import SalesErrorQrTransactionReport from './Sales_Reports/SalesErrorQrTransactionReport';
import SalesTopPerformanceReport from './Sales_Reports/SalesTopPerformanceReport';
import SalesRedemptionReport from './Sales_Reports/SalesRedemptionReport';
import SalesTicketReport from './Sales_Reports/SalesTicketReport';
import Protected from './Protected';
import Page_404 from './Page_404';
import Privacy_Ploicy from './Privacy_Ploicy';
import NewSalesQrTransactionReport from './Sales_Reports/NewSalesQrTransactionReport';
import Web_Privacy_Policy from './Web_Privacy_Policy';
import swal from 'sweetalert';
import PendingRetailer from './PendingRetailer';
import SalesSuccessQrTransactionReport from './Sales_Reports/SalesSuccessQrTransactionReport';
import ReversedQrTransactionReport from './Sales_Reports/ReversedQrTransactionReport';
import TopTenRetailer from './Sales_Reports/TopTenRetailer';
import Disclaimer from './Disclaimer';
import RedemptionReport from './Jk_Reports/RedemptionReport';
import NewEnrollmentReport from './Jk_Reports/NewEnrollmentReport';
import New_Sales_Dashboard from './New_Sales_Dashboard';
import RegistrationForm from './RegistrationForm';
import FeedbackForm from './FeedbackForm';


function Main() {
  const navigate = useNavigate();
  // useEffect(() => {
  //   const checkExpiry = setInterval(() => {
  //     const tokenExpiry = localStorage.getItem('token_expiry');
  //     if (tokenExpiry && new Date().getTime() > tokenExpiry) {
  //       swal("Session Expired", "You have been logged out due to inactivity.", "warning");
  //       localStorage.removeItem('token_expiry');
  //       localStorage.clear();
  //       navigate('/');
  //     }
  //   }, 1000);

  //   return () => clearInterval(checkExpiry); // Cleanup interval on component unmount
  // }, [navigate]);

  return (
    <Routes>
      <Route path="/" element={<LoginWithOtp />}></Route>
      {/* <Route path="/login_with_otp" element={<LoginWithOtp />}></Route> */}
      <Route path="/forgot_password" element={<ForgotPassword />}></Route>
      <Route path="/app/tnc" element={<Terms_Conditions />}></Route>
      <Route
        path="/old_sales_dashboard"
        element={
          <Protected
            Cmp={SalesDashboard}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_dashboard"
        element={
          <Protected
            Cmp={New_Sales_Dashboard}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/add_new_plumber"
        element={
          <Protected Cmp={AddNewPlumber} requiredRoles={["SALES"]} />
        }
      ></Route>
      <Route
        path="/pending_for_approval"
        element={
          <Protected
            Cmp={PendingForApproval}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/approved_retailer"
        element={
          <Protected
            Cmp={ApprovedPlumber}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/rejected_retailer"
        element={
          <Protected
            Cmp={RejectedPlumber}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/pending_retailer"
        element={
          <Protected
            Cmp={PendingRetailer}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_enrollment_report"
        element={
          <Protected
            Cmp={EnrollkmentReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_qr_transaction_report"
        element={
          <Protected
            Cmp={SalesQrTransactionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_error_qr_transaction_report"
        element={
          <Protected
            Cmp={SalesErrorQrTransactionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_success_qr_transaction_report"
        element={
          <Protected
            Cmp={SalesSuccessQrTransactionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_reversed_qr_transaction_report"
        element={
          <Protected
            Cmp={ReversedQrTransactionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>

      <Route
        path="/sales_top_performance_report"
        element={
          <Protected
            Cmp={NewSalesQrTransactionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_redemption_report"
        element={
          <Protected
            Cmp={SalesRedemptionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/sales_ticket_report"
        element={
          <Protected
            Cmp={SalesTicketReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/top_ten_retailers"
        element={
          <Protected
            Cmp={TopTenRetailer}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/redemption_report"
        element={
          <Protected
            Cmp={RedemptionReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/new_enrollment_report"
        element={
          <Protected
            Cmp={NewEnrollmentReport}
            requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
          />
        }
      ></Route>
      <Route
        path="/registrstion_form"
        element={<RegistrationForm />}
      ></Route>
      <Route
        path="/feedback_form"
        element={<FeedbackForm />}
      ></Route>
      <Route path="/*" element={<Page_404 />}></Route>
      <Route path="/app/privacy-policy" element={<Privacy_Ploicy />}></Route>
      <Route path="/privacy-policy" element={<Web_Privacy_Policy />}></Route>
      <Route
        path="new_sales_qr_transaction_report"
        element={<NewSalesQrTransactionReport />}
        requiredRoles={["SALES", "SH", "RO", "HO", "ZO"]}
      ></Route>
      <Route path='/disclaimer' element={<Disclaimer />} />
    </Routes>
  );
}
export default function App() {
  return (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  );
}
